import { QRCodeSVG } from "qrcode.react";

export default function QRCode({ url }: { url: string }): JSX.Element {
  return <QRCodeSVG value={url} size={256} style={{ margin: "auto" }} />;
}
